import { render } from "./ListPager.vue?vue&type=template&id=41868128"
import script from "./ListPager.vue?vue&type=script&lang=js"
export * from "./ListPager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__